export const isLabelAssignable = (label, isAdmin = false) => {
  if (isAdmin) return true;

  return label?.editable_by_agents !== false;
};

export const filterAssignableLabels = (labels = [], isAdmin = false) => {
  return labels.filter(label => isLabelAssignable(label, isAdmin));
};
